<mat-card class="sales-status-card">
  <mat-card-title>IBAN</mat-card-title>
  <mat-card-subtitle>This information is copied to clipboard</mat-card-subtitle>
  <mat-divider inset></mat-divider>

  <div class="text-iban">{{ iban }}</div>

  <mat-card-content> </mat-card-content>
</mat-card>
